<template>
  <div class="head">
    <img
      class="headbg"
      src="../assets/header.svg"
    >
    <div class="inner">
      <div class="forbeslogo">
        <a
          title="forbes.hu"
          href="https://forbes.hu"
        >
          <img
            src="../assets/forbes-head.svg"
            alt="Forbes"
          >
        </a>
        <div class="tamtart">
          Támogatói tartalom
        </div>
      </div>
      <div class="hungarialogo">
        <a
          title="Hungária"
          href="http://www.facebook.com/hungariaextradry"
        >
          <img
            src="../assets/hungaria-header.svg"
            alt="Hungária"
          >
        </a>
      </div>
      <div class="navitems">
        <div class="socials">
          <a
            title="Megosztás a Facebookon"
            href="https://www.facebook.com/sharer/sharer.php?u=https://forbes.hu/extra/borbely-shop-korkep/"
            target="_blank"
          >
            <img
              src="../assets/facebook-icon.svg"
              alt="Megosztás a Facebookon"
            >
          </a>
          <a
            title="Forbes instagram"
            href="https://www.instagram.com/forbeshungary/"
            target="_blank"
          >
            <img
              src="../assets/instagram-icon.svg"
              alt="Forbes instagram"
            >
          </a>
        </div>
        <div class="menu">
          <div
            class="opener"
            v-on:click="menu()"
          >
            <div class="bars">
            </div>
          </div>
          <div class="shopsm">
            <div class="menuitems">
              <router-link
                :class="'menuitem '+item.slug"
                v-for="(item, key) in items"
                :key="key"
                :to="'/shop/'+item.slug"
                @click.native="scrollToElement()"
              >
                <div class="itemname">{{key}}</div>
                <img
                  :src="'./shops/'+item.slug+'.png'"
                  :alt="key"
                >
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'HeadComponent',
  props: {

  },
  methods: {
    menu() {
      document.querySelector('.menu .shopsm').classList.toggle('show');
      document.querySelector('.menu').classList.toggle('open');
      document.querySelector('.head').classList.toggle('open');
    },
    scrollToElement() {
      this.menu();
      const element = document.querySelector(`[data-slug=${this.$route.params.slug}]`);
      const hashpart = window.location.hash.replace('#/shop/', '');
      if (this.$route.params.slug === hashpart) {
        if (element) {
          const ua = window.navigator.userAgent;
          const msie = ua.indexOf('MSIE ');
          // If Internet Explorer, return version number
          if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            setTimeout(() => {
              window.scroll(0, element.offsetTop - 130);
            }, 1000);
          }

          window.scrollTo({
            behavior: 'smooth',
            left: 0,
            top: element.offsetTop - 130,
          });
          setTimeout(() => {
            element.classList.toggle('current');
          }, 1500);
          setTimeout(() => {
            element.classList.toggle('current');
          }, 2500);
        }
      }
    },
    stickyNav() {
      const head = document.querySelector('.head');
      window.addEventListener('scroll', () => {
        if (window.pageYOffset >= 65) {
          head.classList.add('scrolled');
        } else {
          head.classList.remove('scrolled');
        }
      });
      window.addEventListener('load', () => {
        if (window.pageYOffset >= 65) {
          head.classList.add('scrolled');
        } else {
          head.classList.remove('scrolled');
        }
      });
    },
  },
  mounted() {
    this.stickyNav();
  },
  computed: {
    ...mapState(['items']),
  },
};
</script>

<style scoped lang="css">
.head {
  overflow: visible;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 1;
}
.head.scrolled {
  overflow: hidden;
}
.headbg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 162px;
}
.inner {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  grid-template-rows: 65px;
  display: -ms-grid;
  -ms-grid-columns: 1fr auto 1fr;
  -ms-grid-rows: 65px;
  align-items: center;
  position: relative;
}
.inner a {
  display: block;
}
.forbeslogo {
  grid-column: 1/2;
  grid-row: 1/2;
  -ms-grid-column: 1;
  -ms-grid-row: 1;
  justify-self: start;
  display: flex;
  align-items: center;
}
.forbeslogo a {
  height: 25px;
}
.forbeslogo img {
  margin-left: 25px;
  height: 100%;
}
.hungarialogo {
  grid-column: 2/3;
  grid-row: 1/2;
  -ms-grid-column: 2;
  -ms-grid-row: 1;
  justify-self: center;
  text-align: center;
}
.hungarialogo img {
  height: 65px;
  margin-top: 70px;
  margin-left: -14px;
}
.head.scrolled .hungarialogo img {
  height: 60px;
  margin-top: 5px;
}
.navitems {
  grid-column: 3/4;
  grid-row: 1/2;
  -ms-grid-column: 3;
  -ms-grid-row: 1;
  justify-self: end;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
}
.socials {
  margin-right: 30px;
  margin-top: 3px;
  display: flex;
}
.socials a {
  margin: 0 5px;
  padding: 0 10px;
}
.socials img {
  height: 21px;
}
.opener {
  position: relative;
  cursor: pointer;
  height: 35px;
  display: flex;
  align-items: center;
  z-index: 3;
}
.bars {
  background-color: #fff;
  width: 30px;
  height: 3px;
}
.bars:before,
.bars:after {
  content: "";
  height: 3px;
  width: 30px;
  display: block;
  position: absolute;
  background-color: #fff;
}
.bars:before {
  top: 8px;
}
.bars:after {
  bottom: 8px;
}
.open .bars {
  background-color: transparent;
}
.open .bars:before {
  transform: rotate(-45deg) translate(-6px, 4px);
}
.open .bars:after {
  transform: rotate(45deg) translate(-7px, -5px);
}
.menu .shopsm {
  display: none;
}
.menu .shopsm.show {
  position: fixed;
  top: 0px;
  left: 0px;
  width: calc(100% - 20px);
  height: calc(100% - 40px);
  background-color: #1d151c;
  padding: 20px 10px;
  z-index: 2;
  display: block;
}
.menuitems {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  min-height: 100%;
}
.menuitem {
  width: 130px;
  height: 130px;
  text-decoration: none;
  color: #fff;
}
.menuitem img {
  width: 100%;
  height: auto;
}
.itemname {
  display: none;
  color: #fff;
  width: calc(100% - 20px);
  margin: 10px auto -20px auto;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
}
.menuitem:hover {
  background-color: #373038;
  transform: scale(1.5);
}
.menuitem:hover img {
  transform: scale(0.7);
}
.menuitem:hover .itemname {
  display: block;
}
.menu.open .opener {
  position: absolute;
  top: 10px;
  right: -45px;
}
.tamtart {
  text-transform: uppercase;
  color: #fff;
  font-size: 16px;
  display: flex;
  align-items: flex-end;
  margin-left: 20px;
  height: 25px;
}
@media screen and (max-width: 1350px) {
  .menuitem {
    width: 120px;
    height: 120px;
  }
  .menuitems {
    min-height: calc(100vh - 20px);
    margin-top: 20px;
    height: 100%;
  }
  .menu.open .opener {
    right: 0px;
  }
}
@media screen and (max-width: 1220px) {
  .menuitem {
    width: 100px;
    height: 100px;
  }
  .itemname {
    font-size: 10px;
  }
}
@media screen and (max-width: 1000px) {
  .menuitem img {
    display: none;
  }
  .itemname {
    display: block;
    font-size: 12px;
    margin: initial;
    width: 100%;
  }
  .menuitem:hover {
    transform: none;
    background-color: inherit;
  }
  .menuitem {
    width: 100%;
    height: auto;
    margin: 15px 0;
  }
  .menu .shopsm.show {
    overflow-y: scroll;
  }
  .menuitems {
    display: block;
  }
}
@media screen and (max-width: 930px) {
  .forbeslogo {
    flex-wrap: wrap;
  }
  .tamtart {
    flex-basis: calc(100% - 26px);
    margin-left: 26px;
  }
}
@media screen and (max-width: 767px) {
  .head {
    overflow: hidden;
  }
  .head .hungarialogo img {
    height: 60px;
    margin-top: 5px;
  }
  .head.open {
    overflow: visible;
  }
}
@media screen and (max-width: 570px) {
  .tamtart {
    font-size: 13px;
    flex-basis: calc(100% - 70px);
    margin-left: 26px;
    height: auto;
    margin-top: 5px;
  }
}
@media screen and (max-width: 480px) {
  .socials {
    margin-right: 22px;
  }
  .socials a {
    padding: 0px;
  }
  .forbeslogo img {
    margin-left: 0px;
  }
  .head.scrolled .hungarialogo img,
  .head .hungarialogo img {
    height: 45px;
  }
  .tamtart {
    margin-left: 0px;
  }
}
</style>
